export function formatDateToLocalDateTime(hour12, currentDate) {
	let hourCycle;
	
	//If hour12 param is null or not a boolean, set it to false
	if(hour12==null || (hour12!=false && hour12!=true)){
		hourCycle = "h12";
	}else{
		hourCycle = "h23";
	}
	
	var dateTimeFormatOptions = {
			year: "numeric", month: "2-digit", day: "2-digit", 
			hour: "2-digit", minute: "2-digit", second: "2-digit",
			hourCycle: hourCycle
	};
	
	if(currentDate!=null){
		var date = new Date(currentDate);
		currentDate = date.toLocaleTimeString("en-us", dateTimeFormatOptions);
	}
		
	return currentDate;
};

export function formatDateToLocalDateTimeWithMillis(hour12, currentDate) {
	let hourCycle;
	
	//If hour12 param is null or not a boolean, set it to false
	if(hour12==null || (hour12!=false && hour12!=true)){
		hourCycle = "h12";
	}else{
		hourCycle = "h23";
	}
	
	var dateTimeFormatOptions = {
			year: "numeric", month: "2-digit", day: "2-digit", 
			hour: "2-digit", minute: "2-digit", second: "2-digit",
			hourCycle: hourCycle
	};
	
	if(currentDate!=null){
		var date = new Date(currentDate);
		currentDate = date.toLocaleTimeString("en-us", dateTimeFormatOptions) + "." + date.getMilliseconds();
	}
		
	return currentDate;
};

export function formatDateToLocalDate(currentDate) {
	var dateFormatOptions = {
			year: "numeric", month: "2-digit", day: "2-digit"
	};
	
	if(currentDate!=null){
		var date = new Date(currentDate);
		currentDate = date.toLocaleDateString("en-us", dateFormatOptions);
	}
	
	return currentDate;
};